<!---------------------------------------------------------------->
<!-- Installation required                                      -->
<!---------------------------------------------------------------->
<!-- npm i tslib --location=global                              -->
<!-- npm i angular-split --location=global                      -->
<!---------------------------------------------------------------->



<div style="border-radius: 14px" class="container">
  <div class="css-tabs">
    <!-- TAB HEADER -->
    <div class="tab-header" role="tablist" aria-label="Administration">
      <button type="button" class="admin-tab admin-tab--logs" role="tab" [attr.aria-selected]="selectedTab === 0" [class.active]="selectedTab === 0" (click)="selectedTab = 0">
        <span class="admin-tab__face"><mat-icon class="admin-tab__icon">article</mat-icon><span>{{ "app.administration.logsTabTitle" | translate }}</span></span>
      </button>
      <button type="button" class="admin-tab admin-tab--rights" role="tab" [attr.aria-selected]="selectedTab === 1" [class.active]="selectedTab === 1" (click)="selectedTab = 1">
        <span class="admin-tab__face"><mat-icon class="admin-tab__icon">people</mat-icon><span>{{ "app.administration.rightsTabTitle" | translate }}</span></span>
      </button>
      <button type="button" class="admin-tab admin-tab--stats" role="tab" [attr.aria-selected]="selectedTab === 2" [class.active]="selectedTab === 2" (click)="selectedTab = 2">
        <span class="admin-tab__face"><mat-icon class="admin-tab__icon">bar_chart</mat-icon><span>{{ "app.administration.statisticsTabTitle" | translate }}</span></span>
      </button>
      <button type="button" class="admin-tab admin-tab--desk" role="tab" [attr.aria-selected]="selectedTab === 4" [class.active]="selectedTab === 4" (click)="selectedTab = 4">
        <span class="admin-tab__face"><mat-icon class="admin-tab__icon">support_agent</mat-icon><span>{{ "app.administration.supportDesk" | translate }}</span></span>
      </button>
    </div>

    <!-- TAB BODY -->
    <div class="tab-body">
      <!-- ================= LOGS TAB ================= -->
      @if (selectedTab === 0) {
        <div class="logs-toolbar">
          <div class="logs-filters">
            <div class="search-box">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                matInput
                type="text"
                [(ngModel)]="searchInput"
                (keyup)="applySearch($event.target.value)"
                placeholder="{{ 'app.administration.search' | translate }}"
              />
            </div>
            <div class="search-box">
              <mat-icon class="search-icon">event</mat-icon>
              <input
                matInput
                type="text"
                [(ngModel)]="weekCount"
                placeholder="{{ 'app.administration.weekCount' | translate }}"
              />
            </div>
          </div>
          <button style="margin-left: 20px" mat-raised-button color="primary" (click)="execute(false)">
            {{ "app.administration.execute" | translate }}
            <mat-icon>play_arrow</mat-icon>
          </button>
          <button mat-raised-button color="primary" (click)="execute(true)">
            {{ "app.administration.empty" | translate }}
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="my-table mat-elevation-z8">
          <mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="LOG_LogDatetime">
              <mat-header-cell style="max-width: 180px" *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logDateTimeColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell style="max-width: 180px" *matCellDef="let row">
                {{ formatDate(row.LOG_LogDatetime) }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LOG_LogSource">
              <mat-header-cell style="max-width: 150px" *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logSourceColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell style="max-width: 150px" *matCellDef="let row">
                {{ row.LOG_LogSource }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LOG_LogLevel">
              <mat-header-cell style="max-width: 150px" *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logLevelColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell style="max-width: 150px" *matCellDef="let row">
                {{ row.LOG_LogLevel }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LOG_LogMessage">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "app.administration.logMessageColumnHeader" | translate }}
              </mat-header-cell>
              <mat-cell class="clickable-cell" *matCellDef="let row">
                <div class="no-wrap" (click)="openDialog(row.LOG_LogMessage)">
                  {{ row.LOG_LogMessage }}
                </div>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
        </div>
      }

      <!-- ================= RIGHTS TAB ================= -->
      @if (selectedTab === 1) {
        <app-rights></app-rights>
      }

      <!-- ================= STATISTICS TAB ================= -->
      @if (selectedTab === 2) {
        <app-statistics></app-statistics>
      }

      <!-- ================= SQL RUNNER TAB ================= -->
      @if (selectedTab === 4) {
        <app-sql-runner></app-sql-runner>
      }
    </div>
  </div>
</div>

@if (isProcessing) {
  <div class="processing-wrapper">
    <div class="processing-circle"></div>
    <div class="processing-text">
      {{ "app.misc.processing" | translate }}
    </div>
  </div>
}
